import { getCircularSimplifyDataStructureReplacer } from "../../tracker/simplifyDataStructureReplacer";
import * as LK from "livekit-client";
export const simpleDataStructureStringify = (object) => JSON.stringify(object, getCircularSimplifyDataStructureReplacer());
export function getLKTrackSource(_kind) {
    let source = LK.Track.Source.Unknown;
    switch (_kind) {
        case "audio":
            source = LK.Track.Source.Microphone;
            break;
        case "video":
            source = LK.Track.Source.Camera;
            break;
        case "screen":
            source = LK.Track.Source.ScreenShare;
            break;
        case "sound":
            source = LK.Track.Source.ScreenShareAudio;
            break;
    }
    return source;
}
export function getGatherConsumerKind(source) {
    let kind;
    switch (source) {
        case LK.Track.Source.Microphone:
            kind = "audio";
            break;
        case LK.Track.Source.Camera:
            kind = "video";
            break;
        case LK.Track.Source.ScreenShare:
            kind = "screen";
            break;
        case LK.Track.Source.ScreenShareAudio:
            kind = "sound";
            break;
        case LK.Track.Source.Unknown:
            throw Error("Could not find appropriate Consumer kind for source " + source);
    }
    return kind;
}
export function createLocalLiveKitTrack(kind, track) {
    let localTrack;
    if (kind === "video" || kind === "screen") {
        localTrack = new LK.LocalVideoTrack(track);
    }
    else {
        localTrack = new LK.LocalAudioTrack(track);
    }
    const source = getLKTrackSource(kind);
    localTrack.source = source;
    return localTrack;
}
//# sourceMappingURL=utils.js.map